import * as React from "react";

function IcSystemStatusWarningFill16(props) {
  const {
    accentColor: accent = "#0194F3",
    color = "#687176",
    width = 16,
    height = 16,
    title,
    titleId,
  } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-id="IcSystemStatusWarningFill16"
      aria-labelledby={titleId}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.66666 15C0.911744 15 0.429055 14.1955 0.784311 13.5294L7.11764 1.65441C7.49412 0.94853 8.50588 0.948529 8.88235 1.65441L15.2157 13.5294C15.5709 14.1955 15.0883 15 14.3333 15H1.66666ZM7 6.75C7 6.19772 7.44771 5.75 8 5.75C8.55228 5.75 9 6.19772 9 6.75V9C9 9.55229 8.55228 10 8 10C7.44771 10 7 9.55229 7 9V6.75ZM8 11C7.30964 11 6.75 11.5596 6.75 12.25C6.75 12.9404 7.30964 13.5 8 13.5C8.69035 13.5 9.25 12.9404 9.25 12.25C9.25 11.5596 8.69035 11 8 11Z"
        fill={color}
      />
    </svg>
  );
}

export default IcSystemStatusWarningFill16;
